import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Input, Row } from "reactstrap";
import { Triangle } from "react-loader-spinner";
import Flatpickr from "react-flatpickr";
import { Link } from "react-router-dom";
// import { formatDateTime } from "../../../Components/Common/FormatDate";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import { formatDateTime } from "../../../Components/Common/FormatDate";
import ComplimentryService from "../../../services/OrderingServices/ComplimentryService";

const ComplimentryAll = () => {
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 10,
    totalPages: 0,
    totalData: 0,
  });
  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(false);

  // filters
  const today = new Date();
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(today.getMonth() - 1);

  const [dateRange, setDateRange] = useState([oneMonthAgo, today]);

  const [filterText, setFilterText] = useState("");
  const [productId, setProductId] = useState(null);
  const [filterName, setFilterName] = useState("");
  const [filterOrderId, setFilterOrderId] = useState("");

  const formatDate = (date) => {
    if (!date) return null;
    return date.toLocaleDateString("en-CA"); // en-CA gives YYYY-MM-DD
  };

  const fetchData = async (
    page = 1,
    pageSize = pagination.pageSize,
    name = filterName,
    orderId = filterOrderId
  ) => {
    setLoading(true);
    try {
      let response = [];

      if (orderId) {
        // Search by order ID
        response = await ComplimentryService.getByOrder(orderId);
        // Ensure response is an array
        if (!Array.isArray(response)) response = [];
      } else {
        // Fetch all / filtered data
        response = await ComplimentryService.getAll({
          page,
          pageSize,
          itemName: name || "",
          startDate: formatDate(dateRange[0]) || null,
          endDate: formatDate(dateRange[1]) || null,
        });
        // If response is wrapped in data or array, adjust
        if (!Array.isArray(response)) response = response || [];
      }

      setAllData(response);
      setPagination({
        currentPage: page,
        pageSize: pageSize,
        totalPages: Math.ceil(response.length / pageSize),
        totalData: response.length,
      });
    } catch (error) {
      console.error("Error fetching data:", error);
      setAllData([]);
      setPagination((prev) => ({ ...prev, totalData: 0 }));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(1, pagination.pageSize, filterName, filterOrderId);
  }, [dateRange, filterName, filterOrderId]);

  // columns
  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      sortable: false,
      width: "75px",
    },
    {
      name: "Order Id",
      selector: (row) => (
        <Link
          to={`/complimentry-logs/detail/${row?.orderId}`}
          title={row?.orderId}
        >
          {row?.orderId}
        </Link>
      ),
      sortable: true,
    },

    {
      name: "Name",
      selector: (row) => `${row.itemName} `,
      cell: (row) => (
        <Link to={`/item/detail/${row?.itemId}`}>{row.itemName}</Link>
      ),
      sortable: true,
    },

    {
      name: "Qty",
      selector: (row) => row.quantity,
      sortable: true,
      width: "6rem",

      center: true,
    },

    {
      name: "Created At",
      selector: (row) => (
        <span title={row?.createdAt}>{formatDateTime(row.createdAt)}</span>
      ),
      sortable: true,
      center: true,
    },
    {
      name: "Given By",
      selector: (row) => row.givenBy,
      sortable: true,

      center: true,
    },
  ];

  return (
    <>
      <Card>
        <CardBody>
          {/* Filters */}
          <Row className="mb-3">
            <Col md={4}>
              <Flatpickr
                options={{ mode: "range", dateFormat: "Y-m-d" }}
                value={dateRange}
                onChange={(dates) => setDateRange(dates)}
                className="form-control"
                placeholder="Select date range"
              />
            </Col>
            <Col md={4}>
              <Input
                type="text"
                placeholder="Search by name"
                value={filterName}
                onChange={(e) => setFilterName(e.target.value)}
              />
            </Col>
            <Col md={4}>
              <Input
                type="text"
                placeholder="Search by Order Id"
                value={filterOrderId}
                onChange={(e) => setFilterOrderId(e.target.value)}
              />
            </Col>
          </Row>

          {/* Table */}
          <CustomDataTable
            responsive
            striped
            pagination
            paginationServer
            paginationTotalRows={pagination.totalData}
            paginationDefaultPage={pagination.currentPage}
            onChangePage={(page) =>
              fetchData(page, pagination.pageSize, filterName, filterOrderId)
            }
            onChangeRowsPerPage={(newPageSize) =>
              fetchData(1, newPageSize, filterName, filterOrderId)
            }
            fixedHeader
            persistTableHead
            progressPending={loading}
            customStyles={{
              headCells: {
                style: {
                  fontSize: "0.93rem",
                  fontWeight: 610,
                },
              },
              rows: {
                style: {
                  fontSize: "0.9rem",
                },
              },
            }}
            progressComponent={
              <div className="my-3">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
                <h5 className="mt-1">Loading...</h5>
              </div>
            }
            columns={columns}
            data={allData}
          />
        </CardBody>
      </Card>
    </>
  );
};

export default ComplimentryAll;
